import {
  faAward,
  faCameraRetro,
  faFilm,
  faGift,
  faNewspaper,
  faSignIn,
  faSmilePlus,
  faSmileWink,
  faStars,
} from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { HEADER_DISCOUNTS, MOBILE_MENU } from 'src/client/constants/joinCampaigns';
import { useSelector } from '../../../redux';
import { MobileLink } from './MobileLink';
import { MobileSeoCategoriesPicker } from './MobileSeoCategoriesPicker';
import { MobileLiveGirls } from './MobileLiveGirls';
import {
  getHeaderMenuItemEligibility,
  HeaderMenuEligibilityContext,
} from 'src/client/containers/HeaderBar/helpers/useHeaderMenuItemVisibility';

export const MobileLinksList = () => {
  const config = useSelector((state) => state.app.config);
  const user = useSelector((state) => state.auth.user);
  const [joinUrl] = useJoinUrl({ campaign: MOBILE_MENU });
  const [discountJoinUrl] = useJoinUrl({ campaign: HEADER_DISCOUNTS });

  const eligibilityContext: HeaderMenuEligibilityContext = {
    hasUser: Boolean(user),
    userValidSubscription: Boolean(user?.validSubscription),
    configHasBlog: Boolean(config.hasBlog),
    configHasUpdates: Boolean(config.hasUpdates),
    configMoviesActive: Boolean(config.movies?.active),
    configMoviesRequiresAuth: Boolean(config.movies?.requiresAuth),
    enableSeoCategoriesMenu: Boolean(config.featureFlags?.enableSeoCategoriesMenu),
  };
  const mobileEligibleItems = getHeaderMenuItemEligibility(eligibilityContext);

  // Keep this source order aligned with HEADER_MENU_ITEM_IDS priorities/intent
  // (with explicit mobile exceptions handled outside this list).
  return (
    <>
      <MobileLink
        disabled={!mobileEligibleItems.join}
        label="Join Now"
        href={joinUrl}
        icon={faSmilePlus}
        className={'join-now'}
      />
      <MobileLink
        disabled={!mobileEligibleItems.login}
        href={`/login?r=${location.pathname.replace(/^\//, '')}`}
        icon={faSignIn}
        label="Sign In"
      />
      <MobileLink disabled={!mobileEligibleItems.updates} label="Updates" to="/updates" icon={faGift} />
      <MobileLink disabled={!mobileEligibleItems.films} label="Films" to="/erotic-films" icon={faFilm} />
      <MobileLink disabled={!mobileEligibleItems.photos} label="Photos" to="/galleries" icon={faCameraRetro} />
      <MobileLink disabled={!mobileEligibleItems.models} label="Models" to="/models" icon={faStars} />
      <MobileLink
        disabled={!mobileEligibleItems.discounts}
        label="Discounts"
        href={discountJoinUrl}
        icon={faSmileWink}
      />
      <MobileLink disabled={!mobileEligibleItems.partners} label="Partners" to="/trusted-partners" icon={faAward} />
      <MobileLiveGirls isEligible={mobileEligibleItems.liveGirls ?? false} />
      <MobileLink disabled={!mobileEligibleItems.blog} label="Blog" to="/blog" icon={faNewspaper} />
      {mobileEligibleItems.categories && <MobileSeoCategoriesPicker />}
    </>
  );
};
